import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from "../../../../../providers/appProvider"

import Modal from '../../../../UI/Modal/Modal'
import Client from "../../../../../assets/Icon/User"; 
import tbl from '../../../../../assets/Style/Table.module.css' 
import paycl from './CargoAmountModal.module.css'
 import Remove from "../../../../../assets/Icon/Remove";
import { useUpdateEffect } from '../../../../../hooks/useUpdateEffect';
import { useAmount } from '../../../../../hooks/useAmount';
import { baseFileURL } from '../../../../../Api';
import Select from "react-select"; 
import { selectStyle } from './selectStyle';

const CargoAmountModal = ({ cargo,  cargoService, containerService}) => {

    const { appState, app } = useContext(AppContext);

    const [selectedOption, setSelectedOption] = useState(1);


    const formatDate = (dateString) => {

        const purchasedAtDate = new Date(dateString);

        const months = [
            "იან",
            "თებ",
            "მარ",
            "აპრ",
            "მაი",
            "ივნ",
            "ივლ",
            "აგვ",
            "სექ",
            "ოქტ",
            "ნოე",
            "დეკ"
        ];

        const day = purchasedAtDate.getDate();
        const month = months[purchasedAtDate.getMonth()];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month}  ${year}`;
    };

    const [isFirstValidated, setIsFirstValidated] = useState(false)

    const [file, setFile] = useState("null");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {amountService} = useAmount()

    var price = cargo.total_price

    const [newAmount, setNewAmount] = useState({
        amount: 0,
        description: "",
        status_id: selectedOption,
        cargo_id: cargo.id,
        type_id: 2,
    })

    const [validates, setValidates] = useState({})

    const validateAmount = (amount) => {
        const messages = {};

        if (amount.amount < 1) {
            messages.amount = { message: 'მიუთითეთ თანხა', isValid: false };
        }
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };


    const [amounts, setAmounts] = useState([])

    const fetchAmounts = () => {
        amountService.fetchByCargoId(cargo.id)
            .then(amounts => {
                setAmounts(amounts)
            })
            .catch(error => { 
            });
    }

    useEffect(() => {
        if (isModalOpen) {
            fetchAmounts()
        }
    }, [isModalOpen]);
 
    useUpdateEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateAmount(newAmount)
        }
    }, [newAmount]);

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const handleChange = (event) => {
        var val = ""

        if (event.target.name === "amount") {
            val = convertToInt(event.target.value);
        } else {
            val = event.target.value
        }


        setNewAmount({
            ...newAmount,
            [event.target.name]: val
        });
    };


    const handleChangeStatus = (option) => {
  
        setSelectedOption(option.value); 
  
 
            setNewAmount(prevState => ({
                ...prevState,
                status_id: option.value , 

            }));  

         
   
    };

 

    const handleFocus = (e) => {
        if (e.target.value === '0') {
            setNewAmount({
                ...newAmount,
                amount: ""
            });
        }
    };

    const handleBlur = (e) => {
        if (e.target.value === '') {
            let val = convertToInt(0);
            setNewAmount({
                ...newAmount,
                amount: val
            });
        };
    };


    const openModal = () => {
        setValidates({})
        setNewAmount({
            ...newAmount,
            amount: 0,
            description: "",
            cargo_id: cargo.id,
            type_id: 2,
        });
        setIsModalOpen(true)
 
    }

    const onAdd = () => {
        const newForm = new FormData();
        const isValidate = validateAmount(newAmount)


        let updatedTransaction = {
            ...newAmount, 
            amount: selectedOption  === 2 ? -Math.abs(newAmount.amount) : newAmount.amount,
        };
         
        for (let key in updatedTransaction) {
            newForm.append(key, updatedTransaction[key]);
        } 

        

        newForm.append('doc', file);


        if (isValidate === true) {
            amountService.addAmountCargo(newForm)
                .then(response => {
                    //fetchAmounts()
                    containerService.fetchList()

                })
                .catch(error => {
                    console.error(error);
                });

            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
    }
 
    const onRemove = (amountId) => {
        amountService.removeAmount(amountId)
            .then(response => {
                fetchAmounts()
                containerService.fetchList() 
            })
            .catch(error => {
                console.error(error);
            });
    }


    let doneclass = ' '


    const statusOptions = [
        { value: 1, label: "ჩარიცხვა" },
        { value: 2, label: "უკან დაბრუნება" },
      ];
       
   
    const selectedOptionObject = statusOptions.find(option => option.value === selectedOption);
  

      

    return (
        <>
 
            <div  style={{ fontWeight: 'bold', cursor: 'pointer', display: 'block', minHeight: '19px' }} onClick={() => { openModal() }} >
                {
                    cargo.total_paid > 0 ? cargo.total_paid : ''
                }
            </div>

            <Modal isOpen={isModalOpen} size="medium" onClose={() => setIsModalOpen(false)}>

                <div className={paycl.modalHead} >
                    <h3>
                        <span className={paycl.iconHead} > <Client /></span>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ lineHeight: 1, fontSize: '14px', fontWeight: 600 }}>კლიენტის ჩარიცხვა</div>    
                            <div style={{ lineHeight: 1, fontSize: '14px', fontWeight: 600, marginTop: '5px' }}> {cargo.name}</div>    
                        </div>
                         
                    </h3>
                </div>

                <div>
                    <div className={tbl.table + ' ' + paycl.table} style={{ minHeight: 'unset' }}>

                        <table>
                            <thead>
                                <tr>
                                    <th className={paycl.id}>#</th>
                                    <th>ფაილი</th>
                                    <th>თარიღი</th>
                                    <th>თანხა</th>
                                    <th>მომხმარებელი</th>
                                    <th>სტატუსი</th>
                                    <th className={paycl.btntbl}> </th>
                                </tr>
                            </thead>
                            <tbody>

                                {amounts.map((amount, index) =>
                                    <tr>
                                        <td className={paycl.id}>{index + 1}</td>
                                        <td>
                                            {
                                                amount.doc === 'null' || amount.doc &&
                                                <a href={baseFileURL + amount.doc} target='_blank' rel="noopener noreferrer">
                                                    ფაილი
                                                </a>
                                            }
                                        </td>
                                        <td> {formatDate(amount.created_at)} </td>
                                        <td >
                                            <span className={paycl.pricein}>  {amount.amount} $ </span>

                                            {amount.dealer_id > 0 ?
                                                (cargo.dealer?.firstname || '') + ' ' + (cargo.dealer?.lastname || '')
                                                : ""}
                                            {amount.is_deposit ?
                                                "დეპოზიტი"
                                                : ""}

                                        </td>


                                        <td> 
                                        {amount.user ? (
                                            <p>{amount.user.firstname} {amount.user.lastname}</p>
                                        ) : (
                                            <p>N/A</p>
                                        )}
                                        </td>

                                        <td>  
                                            {
                                                amount.status_id === 1 ? "ჩარიცხული " :
                                                amount.status_id === 2 ? "უკან დაბრუნებული " :
                                                "- - -"
                                            }  
                                        </td>

                                        <td className={paycl.btntbl}>
                                            {app.hasPermission("CLIENT_PAY_DELETE") &&
                        
                                                <div className={paycl.btns}>
                                                    <div>
                                                        <span className={paycl.removeBtn} onClick={() => onRemove(amount.id)} ><Remove /> წაშლა</span>
                                                    </div>
                                                </div>
                                            }
                                        </td>

                                    </tr>
                                )}
                            </tbody>
                        </table>

 
                    </div>
                    {app.hasPermission("CLIENT_PAY_ADD") &&
                                                  

                        <div className={paycl.formField}>

                            <legend>გადახდის დამატება</legend>

                            <div className={paycl.row}>

                                {/*
                                <div style={{ width: '100%' }}>
                                    <input type="text" className={paycl.input} name="description" placeholder='აღწერა' value={newAmount.description} onChange={handleChange} />
                                </div> */}
    
                                <div style={{ width: '100%' }}>

                                    <div className={paycl.uploadDiv}>
                                        <input type="file" name="doc" onChange={e => setFile(e.target.files[0])} />
                                    </div>
                                </div>


                                {validates && validates.amount ? validates.amount.message : ""}
    
                                <div style={{ width: '140px' }}>
                                    <div className={paycl.priceInput}>
                                        <div className={paycl.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onFocus={handleFocus} onBlur={handleBlur} className={paycl.input} name="amount" min="0" onChange={handleChange} value={newAmount.amount} />
                                        <div className={paycl.hundred} >.00</div>
                                    </div>
                                </div>


                                <div style={{ width: '100%' }}>

                                    <Select
                                        styles={selectStyle}
                                        options={statusOptions}
                                        value={selectedOptionObject}
                                        onChange={handleChangeStatus}
                                        placeholder="სტატუსი"
                                    />

                                </div>


    
                            </div>

                            <div className={paycl.addBox}>
                                <span onClick={onAdd} className={paycl.addBtn}>გადახდა</span>
                            </div>

                        </div>

                    } 
                </div>
            </Modal>
        </>
    );
};

export default CargoAmountModal;